import React, { useState } from 'react';
import { DISCARD_REASONS, rpcError } from './config';
import { L, Chips } from './ui';

// Descartar un lead con doble confirmación: 1) motivo, 2) confirmación final. Sale de la Bandeja, deja de avisar y no
// cuenta en las métricas. Un supervisor puede recuperarlo desde la ficha.
// `initialReason` preselecciona el motivo; `beforeDiscard` (async, devuelve un error o null) se ejecuta justo antes de descartar.
export default function DiscardControl({ supabase, lead, onDone, compact, initialReason, label, beforeDiscard }) {
  const [step, setStep] = useState(0);
  const [reason, setReason] = useState(initialReason || DISCARD_REASONS[0]);
  const [other, setOther] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const finalReason = reason === 'Otro' ? other.trim() : reason;

  const discard = async () => {
    setBusy(true); setError('');
    if (beforeDiscard) {
      const pre = await beforeDiscard();
      if (pre) { setBusy(false); setError(rpcError(pre)); return; }
    }
    const { error: err } = await supabase.rpc('discard_lead', { p_lead_id: lead.id, p_reason: finalReason || null });
    setBusy(false);
    if (err) { setError(rpcError(err)); return; }
    setStep(0);
    onDone && onDone();
  };

  if (step === 0) {
    return (
      <button type="button" style={{ ...L.danger, ...(compact ? { padding: '6px 10px', fontSize: '0.8rem' } : {}) }} onClick={() => setStep(1)}>
        {label || '🗑️ Descartar lead'}
      </button>
    );
  }
  return (
    <div style={{ ...L.warn, margin: 0, flexBasis: '100%', display: 'grid', gap: '8px' }} role="group" aria-label="Descartar lead">
      {step === 1 ? (
        <>
          <strong>¿Por qué lo descartas?</strong>
          <Chips small value={reason} onChange={setReason} options={[...DISCARD_REASONS, 'Otro'].map(r => ({ key: r, label: r }))} />
          {reason === 'Otro' && (
            <input aria-label="Motivo" placeholder="Escribe el motivo" value={other} maxLength={200}
              onChange={e => setOther(e.target.value)} style={{ ...L.input, marginBottom: 0 }} />
          )}
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            <button type="button" style={{ ...L.secondary, padding: '5px 10px' }} onClick={() => setStep(0)}>Cancelar</button>
            <button type="button" style={{ ...L.danger, padding: '5px 12px' }} disabled={reason === 'Otro' && !other.trim()} onClick={() => setStep(2)}>Continuar</button>
          </div>
        </>
      ) : (
        <>
          <strong>¿Seguro que quieres descartar este lead?</strong>
          <span>Saldrá de la Bandeja, dejará de enviar avisos y no contará en las métricas. Motivo: «{finalReason}».</span>
          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            <button type="button" style={{ ...L.secondary, padding: '5px 10px' }} disabled={busy} onClick={() => setStep(0)}>No, mantenerlo</button>
            <button type="button" style={{ ...L.danger, padding: '5px 12px', fontWeight: 700 }} disabled={busy} onClick={discard}>
              {busy ? 'Descartando…' : 'Sí, descartar definitivamente'}
            </button>
          </div>
        </>
      )}
      {error && <div style={{ ...L.error, margin: 0 }}>{error}</div>}
    </div>
  );
}
